import React from 'react'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import {connect} from "react-redux";
import Loader from 'react-loader-spinner';

import {addUserInfo, removeUserInfo} from "../../modules/user";
import {showToastMessage} from "../../modules/toast";
import {withRouter} from "react-router-dom";
import {NAVER_LOGIN, NAVER_LOGIN_PRODUCTION} from "../../modules/variable/common_variable";
import {showAlertMessage} from "../../modules/alert";
import AddUserInfoDialog from '../user/addUserInfoDialog'
import {showTutorial} from "../../modules/tutorial";

class Authentication extends React.Component {
    state = {
        addUserInfoDialog: {open: false, first: false},
        authenticationCompleted: false
    };

    componentDidMount(){
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillMount() {

        //NAVER LOGIN CHECK
        const naverLogin = new window.naver.LoginWithNaverId(
            {
                clientId: process.env.NODE_ENV.toUpperCase() === 'PRODUCTION' ? NAVER_LOGIN_PRODUCTION.clientId: NAVER_LOGIN.clientId,
                callbackUrl: process.env.NODE_ENV.toUpperCase() === 'PRODUCTION' ? NAVER_LOGIN_PRODUCTION.callbackUrl : NAVER_LOGIN.callbackUrl,
                isPopup: false,
                callbackHandle: false
            }
        );
        naverLogin.init();

        window.addEventListener('load', () => {
            naverLogin.getLoginStatus((status) => {
                if (status) {
                    //CREATE CUSTOM FIREBASE TOKEN
                    const createCustomToken = firebase.functions().httpsCallable('createCustomToken');
                    createCustomToken({uid: naverLogin.user.id}).then((rc) => {
                        if(rc.data.result === 'success'){

                            let userInfo = {uid: naverLogin.user.id,
                                email: naverLogin.user.email,
                                gender: naverLogin.user.gender,
                                age: naverLogin.user.age,
                                name: naverLogin.user.name,
                                isAnonymous: false,
                                isSignedIn: true
                            };
                            //this.props.showToastMessage(userInfo.name + '님 환영합니다.');

                            //SIGN IN WITH TOKEN
                            firebase.auth().signInWithCustomToken(rc.data.token).then((rs) => {

                                //GET ADDITIONAL USER INFO
                                firebase.database().ref('/users/' + userInfo.uid).once('value').then((snapshot) => {
                                    if(!snapshot.exists()){
                                        //first visit
                                        this.props.addUserInfo(userInfo);
                                        this.setState({addUserInfoDialog: {...this.state.addUserInfoDialog, open: true, first: true}})
                                    }else{
                                        //put additional info if exists
                                        const data = snapshot.val();
                                        userInfo.nickname = data.nickname;
                                        this.props.addUserInfo(userInfo);
                                    }

                                    //RECORD ACCESS INFORMATION
                                    try {
                                        let xmlhttp = new XMLHttpRequest();
                                        xmlhttp.open('GET', '//api.ipify.org/?format=json', true);
                                        xmlhttp.onreadystatechange = () => {
                                            if (xmlhttp.readyState === 4) {
                                                if(xmlhttp.status === 200) {
                                                    const obj = JSON.parse(xmlhttp.responseText);

                                                    userInfo.ip = obj.ip;
                                                    userInfo.accessDate = rc.data.date.toString();
                                                    this.props.addUserInfo(userInfo);

                                                    firebase.database().ref('/users_login_history/' + userInfo.uid).child(rc.data.date).set({
                                                        ip: obj.ip,
                                                        uid: userInfo.uid,
                                                        accessDate: rc.data.date.toString()
                                                    });
                                                }
                                            }
                                        };
                                        xmlhttp.send(null);

                                        this.setState({authenticationCompleted: true});
                                    } catch (e) {
                                        firebase.database().ref('/users_login_history/' + userInfo.uid).child(rc.data.date).set({
                                            ip: "0.0.0.0",
                                            uid: userInfo.uid,
                                            accessDate: rc.data.date.toString()
                                        });
                                        console.error(e);
                                        this.setState({authenticationCompleted: true});
                                    }

                                    firebase.database().ref('/users_login_history/' + userInfo.uid).child(rc.data.date).child('leaveDate').onDisconnect().set(new Date().valueOf().toString());
                                });
                            }).catch(error => {
                                console.error(error);
                                this.props.showAlertMessage("로그인이 정상적으로 처리되지 않았습니다. 기능상 문제가 발생합니다.", "로그인 오류");
                            });
                        }else{
                            console.error(rc.data);
                            this.props.showAlertMessage("로그인이 정상적으로 처리되지 않았습니다. 기능상 문제가 발생합니다.", "로그인 오류");
                        }
                    });
                } else {
                    this.setState({authenticationCompleted: true});
                    if(['/schedule', '/privacy'].indexOf(this.props.location.pathname) !== -1){

                    }else{
                        setTimeout(() => {
                            if(!this.props.userInfo || !this.props.userInfo.isSignedIn){
                                this.props.history.push("/intro");
                            }
                        }, 1000);
                    }
                }
            });
        });

        //PROCESS FOR ANONYMOUS
        firebase.auth().onAuthStateChanged((user) => {
            if (user && user.isAnonymous) {
                let userInfo = {uid: user.uid,
                    email: '',
                    gender: '',
                    age: '',
                    name: '익명',
                    nickname: '익명',
                    isAnonymous: true,
                    isSignedIn: true
                };

                //console.log("익명 로그인");
                this.props.addUserInfo(userInfo);

                if(['/schedule'].indexOf(this.props.location.pathname) !== -1){

                }else{
                    this.props.showToastMessage("피크니키를 체험중입니다. 쓰기와 같은 기능 사용이 제한됩니다.", "안내");

                    if(!localStorage.getItem('CONFIRMED_TUTORIAL_ENTIRE_OVERVIEW')){
                        this.props.showTutorial('ENTIRE_OVERVIEW');
                        localStorage.setItem('CONFIRMED_TUTORIAL_ENTIRE_OVERVIEW', "true");
                    }
                    this.props.history.push("/home");
                }
            }
        });
    }

    render() {
        return (
           <div>
               {
                   !this.state.authenticationCompleted ?
                       <div className="loader-puff">
                           <Loader type="ThreeDots" color="#00BFFF" height={80} width={80} />
                           <p>로그인 정보 확인중</p>
                       </div>
                       :
                       null
               }

               {
                   this.state.addUserInfoDialog.open ?
                       <AddUserInfoDialog open={true} first={this.state.addUserInfoDialog.first} hide={() => this.setState({addUserInfoDialog: {...this.state.addUserInfoDialog, open: false}})}/>
                       :
                       null
               }
           </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    addUserInfo: userInfo => dispatch(addUserInfo(userInfo)),
    removeUserInfo: () => dispatch(removeUserInfo()),
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showTutorial: (sort) => dispatch(showTutorial(sort)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Authentication))